module.exports = __webpack_public_path__ + "img/f0fcd.a419168d.svg";